module.exports = __webpack_public_path__ + "img/Question-bg-3.707496e6.png";